import React, { useState } from 'react'
import Footer from '../../../common/footer/Footer'
import Header from '../../../common/header/Header'
import User_Dashbaord_Common_Section from '../user_dashboard_common_section/User_Dashbaord_Common_Section'
import { useNavigate } from 'react-router-dom'

const User_Dashboard_Logout = () => {
  const navigate = useNavigate()
  const [is_Open_logout, set_Is_Open_logout] = useState(true);

  // <---------- Open the Logout Modal ----------->
  const Handle_Is_Open_logout = () => {
    set_Is_Open_logout(!is_Open_logout);
  };

  // <-------- Handle the Logout Functionlity ---------->
  const Handle_User_logout = () => {
    localStorage.clear();
    setTimeout(() => {
      navigate("/")
    })
  }
  return (
    <div>
      {/* <--------- Header section's ------------> */}
      <Header />
      {/* <----------- Dashboard Order list here -----------> */}
      <div className="bg-[#f8f8f8] py-8">
        <div
          className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] pb-5 w-full px-[12px]">
          <div className="myaccount-section w-full">
            <div className="w-full">
              <div className="w-full my-4 sm:my-10">

                <div className="w-full bg-white shadow-xl p-4 sm:p-5">

                  <div className="my_account w-full flex space-x-2 md:space-x-10">
                    <User_Dashbaord_Common_Section />
                    <div className="flex-1 min-w-0">

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <--------- logout modal section's -----------> */}
      {
        is_Open_logout && (
          <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/60 backdrop-blur-[4px] animate-fadeIn">
            <style>{`
              @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
              }
              @keyframes scaleUp {
                from { transform: scale(0.95); opacity: 0; }
                to { transform: scale(1); opacity: 1; }
              }
              .animate-fadeIn {
                animation: fadeIn 0.2s ease-out forwards;
              }
              .animate-scaleUp {
                animation: scaleUp 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
              }
            `}</style>
            
            {/* <!-- Modal Content --> */}
            <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full overflow-hidden border border-gray-100 relative animate-scaleUp">
              
              {/* <!-- Close Button --> */}
              <button 
                className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 active:scale-90 transition-all duration-200 text-2xl font-light leading-none" 
                onClick={() => {
                  Handle_Is_Open_logout()
                  setTimeout(() => {
                    navigate("/user-dashBaord")
                  }, 300)
                }}
                aria-label="Close"
              >
                &times;
              </button>

              {/* <!-- Modal Illustration/Icon --> */}
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-50 text-[#9F2225] mt-8 mb-4 border border-red-100">
                <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
              </div>

              {/* <!-- Modal Header & Description --> */}
              <div className="text-center px-6 pb-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-1">Confirm Logout</h3>
                <p className="text-gray-500 text-sm leading-relaxed">
                  Are you sure you want to log out? You will need to sign in again to access your account dashboard.
                </p>
              </div>

              {/* <!-- Modal Buttons --> */}
              <div className="flex space-x-3 p-4 bg-gray-50/70 border-t border-gray-100">
                <button
                  type="button"
                  className="flex-1 px-4 py-2.5 rounded-xl text-sm font-semibold text-gray-700 bg-white border border-gray-200 hover:bg-gray-100 hover:text-gray-900 active:scale-95 transition-all duration-200 shadow-sm"
                  onClick={() => {
                    Handle_Is_Open_logout()
                    setTimeout(() => {
                      navigate("/user-dashBaord")
                    }, 300)
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="flex-1 px-4 py-2.5 rounded-xl text-sm font-semibold text-white bg-[#9F2225] hover:bg-[#851d20] active:scale-95 transition-all duration-200 shadow-md shadow-red-900/10"
                  onClick={Handle_User_logout}
                >
                  Logout
                </button>
              </div>

            </div>
          </div>
        )
      }

      {/* <-------- footer section's --------------> */}
      <Footer />
    </div>
  )
}

export default User_Dashboard_Logout